import { Paths } from "../../../paths";

export interface MenuItem {
  title: string;
  paths: string[];
  icon: string;
  subMenuKey: string;
  key: string;
  children?: MenuItem[];
}

export const getMenuItems = (t: (key: string) => string): MenuItem[] => [
  {
    title: t('Water Resources Service'),
    paths: [Paths.mapAndStatistics],
    icon: "/sidebar/water.svg",
    subMenuKey: "sub-water",
    key: "/reservoir-history",
    children: [
      {
        title: t('General information'),
        paths: ["/generaldata/personal/dep_wat"],
        icon: "/sidebar/water.svg",
        subMenuKey: "generaldata",
        key: "/generaldata/personal/dep_wat"
      },
      {
        title: t('Water Resources Service'),
        paths: [Paths.mapAndStatistics],
        icon: "/sidebar/water.svg",
        subMenuKey: "mapAndStatistics",
        key: Paths.mapAndStatistics
      }
    ]
  },
  {
    title: t('Chemicalization and plant quarantine'),
    paths: [
      Paths.chemicalization.pesticidespage
    ],
    icon: "/sidebar/chem.svg",
    subMenuKey: "chemicalization",
    key: "/departments/chemicalization",
    children: [
      {
        title: t('General information'),
        paths: ["/generaldata/personal/dep_chem"],
        icon: "/sidebar/water.svg",
        subMenuKey: "generaldata",
        key: "/generaldata/personal/dep_chem"
      },
      {
        title: t('Pesticides'),
        paths: [Paths.chemicalization.pesticidespage],
        icon: "/sidebar/chem.svg",
        subMenuKey: "pesticides",
        key: Paths.chemicalization.pesticidespage
      },
      {
        title: t('Suppliers of mineral fertilizers'),
        paths: ["/mineralfertilizersuppliers"],
        icon: "/sidebar/chem.svg",
        subMenuKey: "fertilizers",
        key: "/mineralfertilizersuppliers"
      },
      {
        title: t('Soil composition enrichment (Fertilizing: March-September)'),
        paths: ["/feeding"],
        icon: "/sidebar/chem.svg",
        subMenuKey: "feeding",
        key: "/feeding"
      },
      {
        title: t('Soil composition enrichment for winter cereals (October-December)'),
        paths: ["/departments/chemicalization/fertilizationcereals"],
        icon: "/sidebar/chem.svg",
        subMenuKey: "fertilization",
        key: "/departments/chemicalization/fertilizationcereals"
      }
    ]
  },
  {
    title: "Кооперация, механизация и инновации",
    paths: ["/mts", "/cooperatives", "/agriculturalmachinery", "/leasing"],
    icon: "/sidebar/mechanic.svg",
    subMenuKey: "mechanization",
    key: "/departments/mechanization",
    children: [
      {
        title: t('General information'),
        paths: ["/generaldata/personal/dep_mech"],
        icon: "/sidebar/water.svg",
        subMenuKey: "generaldata",
        key: "/generaldata/personal/dep_mech"
      },
      {
        title: "МТС",
        paths: ["/mts"],
        icon: "/sidebar/mechanic.svg",
        subMenuKey: "mts",
        key: "/mts"
      },
      {
        title: t('Agricultural cooperatives'),
        paths: ["/cooperatives"],
        icon: "/sidebar/mechanic.svg",
        subMenuKey: "cooperatives",
        key: "/cooperatives"
      },
      {
        title: t('Agricultural machinery'),
        paths: ["/agriculturalmachinery"],
        icon: "/sidebar/mechanic.svg",
        subMenuKey: "machinery",
        key: "/agriculturalmachinery"
      },
      {
        title: t('Leasing of machinery'),
        paths: ["/leasing"],
        icon: "/sidebar/mechanic.svg",
        subMenuKey: "leasing",
        key: "/leasing"
      }
    ]
  },
  {
    title: "Валовый сбор продукции",
    paths: ["/heatmap", "/capacities", "/needsofthepopulation", "/TLC", "/storages", "/largeprocessors", "/exportimport"],
    icon: "/sidebar/pererab.svg",
    subMenuKey: "Gross",
    key: "/departments/Gross",
    children: [
      {
        title: t('General information'),
        paths: ["/generaldata/personal/dep_gross"],
        icon: "/sidebar/water.svg",
        subMenuKey: "generaldata",
        key: "/generaldata/personal/dep_gross"
      },
      {
        title: "Тепловая карта по видам животных",
        paths: ["/heatmap"],
        icon: "/sidebar/mechanic.svg",
        subMenuKey: "heatmap",
        key: "/heatmap"
      },
      {
        title: "Тепловая карта по видам продукции",
        paths: ["/heatmapbytypesofproducts"],
        icon: "/sidebar/mechanic.svg",
        subMenuKey: "heatmapbytypesofproducts",
        key: "/heatmapbytypesofproducts"
      },
      {
        title: "Мощности переработки",
        paths: ["/processingcapacities"],
        icon: "/sidebar/mechanic.svg",
        subMenuKey: "processingcapacities",
        key: "/processingcapacities"
      },
      {
        title: "Потребности населения",
        paths: ["/needsofthepopulation"],
        icon: "/sidebar/mechanic.svg",
        subMenuKey: "needsofthepopulation",
        key: "/needsofthepopulation"
      },
      {
        title: "ТЛЦ",
        paths: ["/tlcorganic"],
        icon: "/sidebar/mechanic.svg",
        subMenuKey: "tlcorganic",
        key: "/tlcorganic"
      },
      {
        title: "Хранилища",
        paths: ["/storageanalitical"],
        icon: "/sidebar/mechanic.svg",
        subMenuKey: "storageanalitical",
        key: "/storageanalitical"
      },
      {
        title: "Крупные переработчики",
        paths: ["/largeprocessors"],
        icon: "/sidebar/mechanic.svg",
        subMenuKey: "largeprocessors",
        key: "/largeprocessors"
      },
      {
        title: "Экспорт/импорт",
        paths: ["/importexport"],
        icon: "/sidebar/mechanic.svg",
        subMenuKey: "importexport",
        key: "/importexport"
      }
    ]
  },
  {
    title: "30+20+10",
    paths: [Paths.treePlusTwo],
    icon: "/sidebar/threeplus.svg",
    subMenuKey: "sub-30+20+10",
    key: "/30+20+10",
    children: [
      {
        title:  "30+20+10 карта",
        paths: ["/treePlusTwo"],
        icon: "/sidebar/water.svg",
        subMenuKey: "generaldata",
        key: "/treePlusTwo"
      },
      {
        title:  "30+20+10 графики",
        paths: ["/graphPirog"],
        icon: "/sidebar/water.svg",
        subMenuKey: "generaldata",
        key: "/graphPirog"
      },
      {
        title:  "Свод данных растениеводство",
        paths: ["/summaryData"],
        icon: "/sidebar/water.svg",
        subMenuKey: "generaldata",
        key: "/summaryData"
      },
      {
        title:  "Свод данных животноводство",
        paths: ["/animalData"],
        icon: "/sidebar/water.svg",
        subMenuKey: "generaldata",
        key: "/animalData"
      },

    ]
  },
];
